import { useEffect } from "react";
import {
  getTicketErrorMessage,
  useGetSupportTicketQuery,
} from "entities/support-ticket";
import { useMarkTicketReadMutation } from "features/read-notifications";

export const useTicketThread = (ticketId: number) => {
  const { data, isLoading, error } = useGetSupportTicketQuery(ticketId, {
    refetchOnMountOrArgChange: true,
  });
  const [markTicketRead] = useMarkTicketReadMutation();
  const isLoaded = Boolean(data);

  // Помечаем прочитанными все ответы по тикету, только когда он
  // действительно загрузился (на чужой id бэк вернёт 404).
  useEffect(() => {
    if (isLoaded) markTicketRead(ticketId);
  }, [isLoaded, ticketId, markTicketRead]);

  return {
    detail: data,
    isLoading,
    errorMessage: getTicketErrorMessage(error),
  };
};
